import { moneyFormat, sentenceCase, validateNull, pascalCase } from "utils";
import { DO_RELEASE_QUICK_FILTERS, QUICK_FILTERS } from "../../constant";
import { STATUS_CHIP } from "constants";
import moment from "moment";

export const getFetchDOReleasePayload = (
  page,
  rowsPerPage,
  filters,
  selectedQuickFilter,
) => {
  const conditions = [];

  if (filters?.orderNumber) {
    conditions.push({
      type: "SIMPLE",
      field: "orderNumber",
      operator: "eq",
      value: filters.orderNumber,
    });
  }

  if (filters?.orderPriority) {
    conditions.push({
      type: "SIMPLE",
      field: "orderPriority",
      operator: "eq",
      value: filters.orderPriority,
    });
  }
  // Add quick filter if selected
  if (
    selectedQuickFilter &&
    selectedQuickFilter !== "All" &&
    selectedQuickFilter !== "Pre-emptive DO"
  ) {
    conditions.push({
      type: "SIMPLE",
      field: "status",
      operator: "eq",
      value: DO_RELEASE_QUICK_FILTERS?.[selectedQuickFilter] || null,
    });
  }

  if (selectedQuickFilter === "Pre-emptive DO") {
    conditions.push({
      type: "SIMPLE",
      field: "expected_fg_date",
      operator: "is",
      value: "TRUE",
    });
  }

  const payload = {
    offset: page * rowsPerPage,
    limit: rowsPerPage,
    date: filters?.uploadDate ?? null,
    filterDto: conditions.length
      ? [
          {
            type: "NESTED",
            logic: "AND",
            conditions,
          },
        ]
      : [],
  };

  return payload;
};

export const getStatusData = (status) => {
  const { success, error, warning } = STATUS_CHIP || {};
  const { Released, Rejected, Approved, Pending } = DO_RELEASE_QUICK_FILTERS;

  switch (status) {
    case Released.toLowerCase():
    case Approved.toLowerCase():
      return { type: success, label: sentenceCase(status) };
    case Rejected.toLowerCase():
      return { type: error, label: sentenceCase(status) };
    case Pending.toLowerCase():
      return { type: warning, label: sentenceCase(status) };
    default:
      return { type: warning, label: sentenceCase(status) };
  }
};

export const getFormattedPaymentRequest = (paymentRequestBreakup) => {
  return [
    {
      label: "Advance required",
      value: moneyFormat(paymentRequestBreakup?.advanceRequired),
    },
    {
      label: "Prorate advance blocked",
      value: moneyFormat(paymentRequestBreakup?.proRatedAdvanceBlocked),
    },
    {
      label: "Amount to be blocked",
      value: moneyFormat(paymentRequestBreakup?.amountToBeBlocked),
    },
  ];
};

export const getFormattedCreditRequest = (creditRequestBreakup) => {
  return [
    {
      label: "Credit required",
      value: moneyFormat(creditRequestBreakup?.creditRequired),
    },
    {
      label: "Amount to be blocked",
      value: moneyFormat(creditRequestBreakup?.amountToBeBlocked),
    },
    {
      label: "Usable limit",
      value: moneyFormat(creditRequestBreakup?.usableCreditLimit),
    },
  ];
};

const validateValue = (value) => {
  return value ? `${value},` : "";
};

export const getAddress = (selectedAddress) => {
  if (!selectedAddress) return "-";
  const {
    address: { address_line_1, address_line_2, city, pincode, state },
  } = selectedAddress;
  const formattedAddress =
    validateValue(address_line_1) +
    validateValue(address_line_2) +
    validateValue(pincode) +
    validateValue(city) +
    validateValue(state);

  return formattedAddress ?? "-";
};

const getFormattedAddress = (address) => {
  if (!address) return "-";

  const line1 = address.addressLine1 ?? address.address_line_1;
  const line2 = address.addressLine2 ?? address.address_line_2;
  const city = address.city;
  const district = address.district;
  const state = address.state;
  const pincode = address.pincode;

  return `
  ${validateValue(line1)}
  ${validateValue(line2)}
  ${validateValue(city)}
  ${validateValue(district)}
  ${validateValue(state)}
  ${validateValue(pincode)}
  `;
};

export const getShipFromAddress = (sourceSeller) => {
  let shipFrom = "-";
  if (sourceSeller) {
    const { shippingAddress } = sourceSeller;
    if (shippingAddress) {
      shipFrom = getFormattedAddress(shippingAddress);
    }
  }
  return shipFrom;
};

export const getBillFromAddress = (sourceSeller) => {
  let billFrom = "-";
  if (sourceSeller) {
    const { billingAddress } = sourceSeller;
    if (billingAddress) {
      billFrom = getFormattedAddress(billingAddress);
    }
  }
  return billFrom;
};

export const getPickupAddress = (pickupAddress) => {
  let pickupAdd = "-";
  if (pickupAddress) {
    pickupAdd = getFormattedAddress(pickupAddress);
  }
  return pickupAdd;
};

export const formatSourceSellerData = (sourceSeller) => {
  const shipFromData = getShipFromAddress(sourceSeller);
  const billFromData = getBillFromAddress(sourceSeller);
  const formattedData = {
    Name: validateNull(pascalCase(sourceSeller?.companyName)),
    "Mobile no.": validateNull(sourceSeller?.mobileNumber),
    "Email ID": validateNull(sourceSeller?.email),
    GSTIN: validateNull(sourceSeller?.gstin),
    "Ship from": validateNull(shipFromData?.trim()),
    "Bill from": validateNull(billFromData?.trim()),
    "Seller Display name": validateNull(pascalCase(sourceSeller?.name)),
  };
  return formattedData;
};

export const formatSellerInfo = (sellerDetails) => {
  const formattedData = {
    Name: validateNull(pascalCase(sellerDetails?.sellerName)),
    GSTIN: validateNull(sellerDetails?.gstin),
  };
  return formattedData;
};

export const formatBuyerInfo = (buyerName, buyerGstIn) => {
  const formattedData = {
    Name: validateNull(pascalCase(buyerName)),
    GSTIN: validateNull(buyerGstIn),
  };
  return formattedData;
};

const safeFormatDate = (value) => {
  return moment(value).isValid() ? moment(value).format("DD/MM/YYYY") : "-";
};

export const formatPickUpDetails = (
  pickupSlotFrom,
  pickupSlotTo,
  pickupLocation,
  pickupAddress,
) => {
  const pickup_Address = getPickupAddress(pickupAddress);
  const formattedData = {
    "Pick From": safeFormatDate(pickupSlotFrom),
    "Pick To": safeFormatDate(pickupSlotTo),
    "Pickup Location": validateNull(pascalCase(pickupLocation)),
    "Pickup Address": validateNull(pickup_Address?.trim()),
  };
  return formattedData;
};
